/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { IncustControllersClientClientPaymentWalletCardPassword200ResponseApiModel } from '../api-models/incust-controllers-client-client-payment-wallet-card-password200-response';
// @ts-ignore
import { IncustControllersClientClientPaymentWalletCardPasswordRequestApiModel } from '../api-models/incust-controllers-client-client-payment-wallet-card-password-request';
// @ts-ignore
import { IncustControllersClientClientPaymentWalletPaymentOtpRequestApiModel } from '../api-models/incust-controllers-client-client-payment-wallet-payment-otp-request';
// @ts-ignore
import { IncustControllersClientClientPaymentWalletPaymentStatusRequestApiModel } from '../api-models/incust-controllers-client-client-payment-wallet-payment-status-request';
// @ts-ignore
import { MessageResponseApiModel } from '../api-models/message-response';
// @ts-ignore
import { PaymentCardManageApiModel } from '../api-models/payment-card-manage';
// @ts-ignore
import { PaymentCardManageResultApiModel } from '../api-models/payment-card-manage-result';
// @ts-ignore
import { PaymentInfoApiModel } from '../api-models/payment-info';
// @ts-ignore
import { PaymentInitDataApiModel } from '../api-models/payment-init-data';
// @ts-ignore
import { PaymentStatusApiModel } from '../api-models/payment-status';
// @ts-ignore
import { PaymentWalletApiModel } from '../api-models/payment-wallet';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { ClientApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: ClientApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * Returns payment info
   * @endpoint get /pmt/info/{payment_id}
   * @param paymentId Payment ID
   * @param transactionInfo Include transaction info
   * @param goodsItemInfo Include goods item info
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentInfo(
    paymentId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentInfoApiModel>;
  public incustControllersClientClientPaymentInfo(
    paymentId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentInfoApiModel>>;
  public incustControllersClientClientPaymentInfo(
    paymentId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentInfoApiModel>>;
  public incustControllersClientClientPaymentInfo(
    paymentId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (paymentId === null || paymentId === undefined) {
      throw new Error(
        'Required parameter paymentId was null or undefined when calling incustControllersClientClientPaymentInfo.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'transaction_info',
      <any>transactionInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'goods_item_info',
      <any>goodsItemInfo,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/info/${this.configuration.encodeParam({
      name: 'paymentId',
      value: paymentId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentInfoApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Returns information about a mobile-app type payment that needs to be processed, by terminal
   * @endpoint get /pmt/info/terminal/{terminal_id}
   * @param terminalId Terminal ID
   * @param transactionInfo Include transaction info
   * @param goodsItemInfo Include goods item info
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentInfoByTerminal(
    terminalId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentInfoApiModel>;
  public incustControllersClientClientPaymentInfoByTerminal(
    terminalId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentInfoApiModel>>;
  public incustControllersClientClientPaymentInfoByTerminal(
    terminalId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentInfoApiModel>>;
  public incustControllersClientClientPaymentInfoByTerminal(
    terminalId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (terminalId === null || terminalId === undefined) {
      throw new Error(
        'Required parameter terminalId was null or undefined when calling incustControllersClientClientPaymentInfoByTerminal.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'transaction_info',
      <any>transactionInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'goods_item_info',
      <any>goodsItemInfo,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/info/terminal/${this.configuration.encodeParam({
      name: 'terminalId',
      value: terminalId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentInfoApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Returns information about a mobile-app type payment that needs to be processed, by transaction
   * @endpoint get /pmt/info/transaction/{transaction_id}
   * @param transactionId Transaction ID
   * @param transactionInfo Include transaction info
   * @param goodsItemInfo Include goods item info
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentInfoByTransaction(
    transactionId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentInfoApiModel>;
  public incustControllersClientClientPaymentInfoByTransaction(
    transactionId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentInfoApiModel>>;
  public incustControllersClientClientPaymentInfoByTransaction(
    transactionId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentInfoApiModel>>;
  public incustControllersClientClientPaymentInfoByTransaction(
    transactionId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (transactionId === null || transactionId === undefined) {
      throw new Error(
        'Required parameter transactionId was null or undefined when calling incustControllersClientClientPaymentInfoByTransaction.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'transaction_info',
      <any>transactionInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'goods_item_info',
      <any>goodsItemInfo,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/info/transaction/${this.configuration.encodeParam({
      name: 'transactionId',
      value: transactionId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentInfoApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Returns mobile payment wallet
   * @endpoint get /pmt/wallet
   * @param businessId Unique identifier of business
   * @param loyaltyId Unique identifier of loyalty
   * @param posId Unique identifier of POS
   * @param terminalId Unique identifier of Terminal
   * @param currency Currency
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWallet(
    businessId?: string,
    loyaltyId?: string,
    posId?: string,
    terminalId?: string,
    currency?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PaymentWalletApiModel>>;
  public incustControllersClientClientPaymentWallet(
    businessId?: string,
    loyaltyId?: string,
    posId?: string,
    terminalId?: string,
    currency?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PaymentWalletApiModel>>>;
  public incustControllersClientClientPaymentWallet(
    businessId?: string,
    loyaltyId?: string,
    posId?: string,
    terminalId?: string,
    currency?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PaymentWalletApiModel>>>;
  public incustControllersClientClientPaymentWallet(
    businessId?: string,
    loyaltyId?: string,
    posId?: string,
    terminalId?: string,
    currency?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'business_id',
      <any>businessId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loyalty_id',
      <any>loyaltyId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pos_id',
      <any>posId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'terminal_id',
      <any>terminalId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'currency',
      <any>currency,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PaymentWalletApiModel>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Returns mobile payment wallet by type
   * @endpoint get /pmt/wallet/{wallet_type}
   * @param walletType Type of payment wallet
   * @param businessId Unique identifier of business
   * @param loyaltyId Unique identifier of loyalty
   * @param posId Unique identifier of POS
   * @param terminalId Unique identifier of Terminal
   * @param currency Currency
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWalletByType(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    businessId?: string,
    loyaltyId?: string,
    posId?: string,
    terminalId?: string,
    currency?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentWalletApiModel>;
  public incustControllersClientClientPaymentWalletByType(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    businessId?: string,
    loyaltyId?: string,
    posId?: string,
    terminalId?: string,
    currency?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentWalletApiModel>>;
  public incustControllersClientClientPaymentWalletByType(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    businessId?: string,
    loyaltyId?: string,
    posId?: string,
    terminalId?: string,
    currency?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentWalletApiModel>>;
  public incustControllersClientClientPaymentWalletByType(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    businessId?: string,
    loyaltyId?: string,
    posId?: string,
    terminalId?: string,
    currency?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (walletType === null || walletType === undefined) {
      throw new Error(
        'Required parameter walletType was null or undefined when calling incustControllersClientClientPaymentWalletByType.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'business_id',
      <any>businessId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loyalty_id',
      <any>loyaltyId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pos_id',
      <any>posId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'terminal_id',
      <any>terminalId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'currency',
      <any>currency,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet/${this.configuration.encodeParam({
      name: 'walletType',
      value: walletType,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType:
        "'ipay' | 'stripe' | '4bill' | 'eway' | 'flutterwave' | 'global-payments' | 'wave'",
      dataFormat: undefined
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentWalletApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Сard password managements for payment wallet
   * @endpoint post /pmt/wallet/cardpassword/{action}
   * @param action Action type
   * @param data Operation data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWalletCardPassword(
    action: 'set' | 'reset',
    data: IncustControllersClientClientPaymentWalletCardPasswordRequestApiModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<IncustControllersClientClientPaymentWalletCardPassword200ResponseApiModel>;
  public incustControllersClientClientPaymentWalletCardPassword(
    action: 'set' | 'reset',
    data: IncustControllersClientClientPaymentWalletCardPasswordRequestApiModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<IncustControllersClientClientPaymentWalletCardPassword200ResponseApiModel>
  >;
  public incustControllersClientClientPaymentWalletCardPassword(
    action: 'set' | 'reset',
    data: IncustControllersClientClientPaymentWalletCardPasswordRequestApiModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<IncustControllersClientClientPaymentWalletCardPassword200ResponseApiModel>
  >;
  public incustControllersClientClientPaymentWalletCardPassword(
    action: 'set' | 'reset',
    data: IncustControllersClientClientPaymentWalletCardPasswordRequestApiModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (action === null || action === undefined) {
      throw new Error(
        'Required parameter action was null or undefined when calling incustControllersClientClientPaymentWalletCardPassword.'
      );
    }
    if (data === null || data === undefined) {
      throw new Error(
        'Required parameter data was null or undefined when calling incustControllersClientClientPaymentWalletCardPassword.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet/cardpassword/${this.configuration.encodeParam(
      {
        name: 'action',
        value: action,
        in: 'path',
        style: 'simple',
        explode: false,
        dataType: "'set' | 'reset'",
        dataFormat: undefined
      }
    )}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<IncustControllersClientClientPaymentWalletCardPassword200ResponseApiModel>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: data,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Manage payment wallet
   * @endpoint post /pmt/wallet/{wallet_type}/{action}
   * @param walletType Type of payment wallet
   * @param action Action type
   * @param data Operation data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWalletManageWData(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    action: 'register' | 'invite' | 'cardadd' | 'carddelete',
    data: PaymentCardManageApiModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentCardManageResultApiModel>;
  public incustControllersClientClientPaymentWalletManageWData(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    action: 'register' | 'invite' | 'cardadd' | 'carddelete',
    data: PaymentCardManageApiModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentCardManageResultApiModel>>;
  public incustControllersClientClientPaymentWalletManageWData(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    action: 'register' | 'invite' | 'cardadd' | 'carddelete',
    data: PaymentCardManageApiModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentCardManageResultApiModel>>;
  public incustControllersClientClientPaymentWalletManageWData(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    action: 'register' | 'invite' | 'cardadd' | 'carddelete',
    data: PaymentCardManageApiModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (walletType === null || walletType === undefined) {
      throw new Error(
        'Required parameter walletType was null or undefined when calling incustControllersClientClientPaymentWalletManageWData.'
      );
    }
    if (action === null || action === undefined) {
      throw new Error(
        'Required parameter action was null or undefined when calling incustControllersClientClientPaymentWalletManageWData.'
      );
    }
    if (data === null || data === undefined) {
      throw new Error(
        'Required parameter data was null or undefined when calling incustControllersClientClientPaymentWalletManageWData.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet/${this.configuration.encodeParam({
      name: 'walletType',
      value: walletType,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType:
        "'ipay' | 'stripe' | '4bill' | 'eway' | 'flutterwave' | 'global-payments' | 'wave'",
      dataFormat: undefined
    })}/${this.configuration.encodeParam({
      name: 'action',
      value: action,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: "'register' | 'invite' | 'cardadd' | 'carddelete'",
      dataFormat: undefined
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentCardManageResultApiModel>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: data,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Manage payment wallet
   * @endpoint post /pmt/wallet/{wallet_type}/{action}/{referrer}
   * @param walletType Type of payment wallet
   * @param action Action type
   * @param referrer Referrer
   * @param data Operation data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWalletManageWDataEx(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    action: 'register' | 'invite' | 'cardadd' | 'carddelete',
    referrer: string,
    data: PaymentCardManageApiModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentCardManageResultApiModel>;
  public incustControllersClientClientPaymentWalletManageWDataEx(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    action: 'register' | 'invite' | 'cardadd' | 'carddelete',
    referrer: string,
    data: PaymentCardManageApiModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentCardManageResultApiModel>>;
  public incustControllersClientClientPaymentWalletManageWDataEx(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    action: 'register' | 'invite' | 'cardadd' | 'carddelete',
    referrer: string,
    data: PaymentCardManageApiModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentCardManageResultApiModel>>;
  public incustControllersClientClientPaymentWalletManageWDataEx(
    walletType:
      | 'ipay'
      | 'stripe'
      | '4bill'
      | 'eway'
      | 'flutterwave'
      | 'global-payments'
      | 'wave',
    action: 'register' | 'invite' | 'cardadd' | 'carddelete',
    referrer: string,
    data: PaymentCardManageApiModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (walletType === null || walletType === undefined) {
      throw new Error(
        'Required parameter walletType was null or undefined when calling incustControllersClientClientPaymentWalletManageWDataEx.'
      );
    }
    if (action === null || action === undefined) {
      throw new Error(
        'Required parameter action was null or undefined when calling incustControllersClientClientPaymentWalletManageWDataEx.'
      );
    }
    if (referrer === null || referrer === undefined) {
      throw new Error(
        'Required parameter referrer was null or undefined when calling incustControllersClientClientPaymentWalletManageWDataEx.'
      );
    }
    if (data === null || data === undefined) {
      throw new Error(
        'Required parameter data was null or undefined when calling incustControllersClientClientPaymentWalletManageWDataEx.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet/${this.configuration.encodeParam({
      name: 'walletType',
      value: walletType,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType:
        "'ipay' | 'stripe' | '4bill' | 'eway' | 'flutterwave' | 'global-payments' | 'wave'",
      dataFormat: undefined
    })}/${this.configuration.encodeParam({
      name: 'action',
      value: action,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: "'register' | 'invite' | 'cardadd' | 'carddelete'",
      dataFormat: undefined
    })}/${this.configuration.encodeParam({
      name: 'referrer',
      value: referrer,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentCardManageResultApiModel>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: data,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Payment from wallet
   * @endpoint post /pmt/wallet/payment
   * @param data Operation data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWalletPayment(
    data: PaymentInitDataApiModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentStatusApiModel>;
  public incustControllersClientClientPaymentWalletPayment(
    data: PaymentInitDataApiModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentStatusApiModel>>;
  public incustControllersClientClientPaymentWalletPayment(
    data: PaymentInitDataApiModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentStatusApiModel>>;
  public incustControllersClientClientPaymentWalletPayment(
    data: PaymentInitDataApiModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (data === null || data === undefined) {
      throw new Error(
        'Required parameter data was null or undefined when calling incustControllersClientClientPaymentWalletPayment.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet/payment`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentStatusApiModel>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: data,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Payment from wallet
   * @endpoint post /pmt/wallet/payment/{referrer}
   * @param referrer Referrer
   * @param data Operation data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWalletPaymentEx(
    referrer: string,
    data: PaymentInitDataApiModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentStatusApiModel>;
  public incustControllersClientClientPaymentWalletPaymentEx(
    referrer: string,
    data: PaymentInitDataApiModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentStatusApiModel>>;
  public incustControllersClientClientPaymentWalletPaymentEx(
    referrer: string,
    data: PaymentInitDataApiModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentStatusApiModel>>;
  public incustControllersClientClientPaymentWalletPaymentEx(
    referrer: string,
    data: PaymentInitDataApiModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (referrer === null || referrer === undefined) {
      throw new Error(
        'Required parameter referrer was null or undefined when calling incustControllersClientClientPaymentWalletPaymentEx.'
      );
    }
    if (data === null || data === undefined) {
      throw new Error(
        'Required parameter data was null or undefined when calling incustControllersClientClientPaymentWalletPaymentEx.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet/payment/${this.configuration.encodeParam({
      name: 'referrer',
      value: referrer,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentStatusApiModel>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: data,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * OTP verification for payment from wallet
   * @endpoint post /pmt/wallet/payment/otp
   * @param data Operation data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWalletPaymentOtp(
    data: IncustControllersClientClientPaymentWalletPaymentOtpRequestApiModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentStatusApiModel>;
  public incustControllersClientClientPaymentWalletPaymentOtp(
    data: IncustControllersClientClientPaymentWalletPaymentOtpRequestApiModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentStatusApiModel>>;
  public incustControllersClientClientPaymentWalletPaymentOtp(
    data: IncustControllersClientClientPaymentWalletPaymentOtpRequestApiModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentStatusApiModel>>;
  public incustControllersClientClientPaymentWalletPaymentOtp(
    data: IncustControllersClientClientPaymentWalletPaymentOtpRequestApiModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (data === null || data === undefined) {
      throw new Error(
        'Required parameter data was null or undefined when calling incustControllersClientClientPaymentWalletPaymentOtp.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet/payment/otp`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentStatusApiModel>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: data,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Request of status for payment from wallet
   * @endpoint post /pmt/wallet/payment/status
   * @param data Operation data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentWalletPaymentStatus(
    data: IncustControllersClientClientPaymentWalletPaymentStatusRequestApiModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PaymentStatusApiModel>;
  public incustControllersClientClientPaymentWalletPaymentStatus(
    data: IncustControllersClientClientPaymentWalletPaymentStatusRequestApiModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PaymentStatusApiModel>>;
  public incustControllersClientClientPaymentWalletPaymentStatus(
    data: IncustControllersClientClientPaymentWalletPaymentStatusRequestApiModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PaymentStatusApiModel>>;
  public incustControllersClientClientPaymentWalletPaymentStatus(
    data: IncustControllersClientClientPaymentWalletPaymentStatusRequestApiModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (data === null || data === undefined) {
      throw new Error(
        'Required parameter data was null or undefined when calling incustControllersClientClientPaymentWalletPaymentStatus.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/wallet/payment/status`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<PaymentStatusApiModel>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: data,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Returns information about all payments by transaction
   * @endpoint get /pmt/payments/transaction/{transaction_id}
   * @param transactionId Transaction ID
   * @param transactionInfo Include transaction info
   * @param goodsItemInfo Include goods item info
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientPaymentsByTransactions(
    transactionId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PaymentInfoApiModel>>;
  public incustControllersClientClientPaymentsByTransactions(
    transactionId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PaymentInfoApiModel>>>;
  public incustControllersClientClientPaymentsByTransactions(
    transactionId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PaymentInfoApiModel>>>;
  public incustControllersClientClientPaymentsByTransactions(
    transactionId: string,
    transactionInfo?: boolean,
    goodsItemInfo?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (transactionId === null || transactionId === undefined) {
      throw new Error(
        'Required parameter transactionId was null or undefined when calling incustControllersClientClientPaymentsByTransactions.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'transaction_info',
      <any>transactionInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'goods_item_info',
      <any>goodsItemInfo,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/pmt/payments/transaction/${this.configuration.encodeParam(
      {
        name: 'transactionId',
        value: transactionId,
        in: 'path',
        style: 'simple',
        explode: false,
        dataType: 'string',
        dataFormat: 'uuid'
      }
    )}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PaymentInfoApiModel>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }
}
